import { SignIn, SignUp } from '@clerk/clerk-react';

/* Centered auth screens on the Triton cream background. Same Clerk instance as
   tritonIQ, so Triton staff sign in with their existing login. */
function AuthShell({ children }: { children: React.ReactNode }) {
  return (
    <div className="auth-shell">
      <div className="auth-shell__brand">
        <img src="/triton-logo.png" alt="Triton" className="auth-shell__logo" />
      </div>
      {children}
    </div>
  );
}

export function SignInPage() {
  return (
    <AuthShell>
      <SignIn signUpUrl="/sign-up" forceRedirectUrl="/" />
    </AuthShell>
  );
}

export function SignUpPage() {
  return (
    <AuthShell>
      <SignUp signInUrl="/sign-in" forceRedirectUrl="/" />
    </AuthShell>
  );
}
